<dx-chart
  class="chart"
  palette="bright"
  [dataSource]="dataSource">
  <dxo-title horizontalAlignment="center" [text]="options.text + ' ('+options.unit+')'">
    <dxo-font [weight]="300" [size]="20"></dxo-font>
  </dxo-title>

  <dxi-value-axis type="continuous">
    <dxo-label [customizeText]="options.customizeText"></dxo-label>
  </dxi-value-axis>

  <dxo-legend [visible]="false"></dxo-legend>

  <dxo-common-axis-settings>
    <dxo-grid [visible]="true"></dxo-grid>
  </dxo-common-axis-settings>

  <dxo-adaptive-layout width="100%"></dxo-adaptive-layout>

  <dxo-export [enabled]="true"></dxo-export>

  <dxo-zoom-and-pan
    [dragToZoom]="true"
    valueAxis="none"
    argumentAxis="both"
  ></dxo-zoom-and-pan>

  <dxi-series
    argumentField="date"
    [valueField]="options.valueField"
    [color]="options.color"
    [name]="options.text">

    <dxo-label
      [visible]="true"
      position="columns"
      [customizeText]="options.customizeText">
      <dxo-font [size]="12"></dxo-font>
      <dxo-connector
        [visible]="true"
        [width]="0.5"></dxo-connector>
    </dxo-label>

    <dxo-aggregation [enabled]="true" [method]="options.aggregationMethod"></dxo-aggregation>
  </dxi-series>

  <dxo-argument-axis argumentType="datetime" [aggregationInterval]="aggregationInterval"></dxo-argument-axis>

  <dxo-tooltip
    [enabled]="true"
    [customizeTooltip]="customizeTooltip">
  </dxo-tooltip>
</dx-chart>
